import { BannerErrorConfigModel } from '../../../Common/Misc/models/banner-error-config.model';

export enum WireBannerErrorTypeEnum {
    WIRE_HEADER_ERROR = 'WireHeaderError',
    WIRE_LOGO_ERROR = 'WireLogoError',
    WIRE_ADDRESS_ERROR = 'WireAddressError',
    WIRE_NAME_ERROR = 'WireNameError',
    WIRE_CONTACT_NAME_ERROR = 'WireContactNameError',
    WIRE_CONTACT_EMAIL_ERROR = 'WireContactEmailError'


}

export const bannerErrorsMap = new Map<string, BannerErrorConfigModel>([
    [WireBannerErrorTypeEnum.WIRE_HEADER_ERROR, {errorId: 'header_errors',label: 'Amplify.headerBlock.blockLabel'}],
    [WireBannerErrorTypeEnum.WIRE_LOGO_ERROR, {errorId: 'logo_error',label: 'Amplify.fakeBlockType.companyLogo'}],
    [WireBannerErrorTypeEnum.WIRE_ADDRESS_ERROR, {errorId: 'address_error',label: 'Amplify.fakeBlockType.companyAddress'}],
    [WireBannerErrorTypeEnum.WIRE_NAME_ERROR, {errorId: 'name_error',label: 'Amplify.wire.name.input.label'}],
    [WireBannerErrorTypeEnum.WIRE_CONTACT_NAME_ERROR, {errorId: 'contactName_error',label: 'Amplify.wire.editorialContactCommunication.contactName'}],
    [WireBannerErrorTypeEnum.WIRE_CONTACT_EMAIL_ERROR, {errorId: 'contactEmail_errors',label: 'Amplify.wire.editorialContactCommunication.contactEmail'}]

]);

